import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatIconRegistry } from '@angular/material/icon'
import { DomSanitizer } from '@angular/platform-browser'
import * as moment from 'moment'
import { Subscription } from 'rxjs'
import { Client } from '../shared/client/client'
import { ClientService } from '../shared/client/client.service'
import { Dav } from './shared/dav'
import { DavService } from './shared/dav.service'

@Component({
  selector: 'app-dav',
  templateUrl: './dav.component.html',
  styleUrls: ['./dav.component.scss']
})
export class DavComponent implements OnInit, OnDestroy {

  currentClient: Client
  dav: Dav
  select: string = ""
  loading: boolean = false
  majToday: boolean = false

  subClient: Subscription

  constructor(protected clientService: ClientService,
    protected davService: DavService,
    protected matIconRegistry: MatIconRegistry,
    protected domSanitizer: DomSanitizer
  ) {
    this.generateMatIcon()
  }

  ngOnInit() {
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.currentClient = client
      this.davService.getProfileOfDav(this.currentClient.dav.id).subscribe((data) => {
        this.dav = data
        if (this.dav && this.dav.date_derniere_maj) {
          this.majToday = moment().format("DD/MM/YYYY") == moment(this.dav.date_derniere_maj).format("DD/MM/YYYY")
        }
      })
    })
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  downloadMaj() {
    this.loading = true
    if (this.currentClient) {
      this.davService.downloadMajDav(this.currentClient.id, this.currentClient.dav.nom, false).subscribe((data) => {
        this.davService.getProfileOfDav(this.currentClient.dav.id).subscribe((data) => {
          this.select = ""
          this.dav = data
          this.majToday = true
          this.loading = false
        }, error => this.loading = false)
      }, error => this.loading = false)
    }
  }

  reDownloadMaj() {
    this.loading = true
    if (this.currentClient) {
      this.davService.downloadMajDav(this.currentClient.id, this.currentClient.dav.nom, true).subscribe((data) => {
        this.loading = false
      }, error => this.loading = false)
    }
  }

  downloadPuces() {
    this.loading = true
    if (this.currentClient) {
      this.davService.downloadPuces(this.currentClient.id).subscribe((data) => {
        this.loading = false
      }, error => this.loading = false)
    }
  }

  download() {
    switch (this.select) {
      case "downloadMaj":
        this.downloadMaj()
        break
      case "reDownloadMaj":
        this.reDownloadMaj()
        break
      case "downloadPuces":
        this.downloadPuces()
        break
      default:
        break
    }
  }

  generateMatIcon(): void {
    this.matIconRegistry.addSvgIcon(
      'download',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/download.svg')
    )
    this.matIconRegistry.addSvgIcon(
      're-download',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/re-download.svg')
    )
    this.matIconRegistry.addSvgIcon(
      'all',
      this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/pictogrammes/download-puces.svg')
    )
  }
}
